export const links = [
    {
        label: 'O nas',
        href: '/i/o-nas'
    },
    {
        label: 'Aktualności',
        href: '/i/aktualnosci'
    },
    {
        label: 'Mapa strony',
        href: '/i/mapa-strony'
    },
    {
        label: 'Kontakt',
        href: '/i/kontakt'
    },
    {
        label: 'Oferta',
        href: 'https://dolacz.opineo.pl/'
    }
] as {
    label: string;
    href: string;
}[];
